/** @format */

import React from 'react';
import { ImageComparisonProps } from '../paragraph-modals';
import {
  ReactCompareSlider,
  ReactCompareSliderImage,
} from 'react-compare-slider';
import { getWidenImageUrl } from '@services/image-services';

interface ImageComparisonParagraphData {
  paragraphData: ImageComparisonProps;
}

/**
 * Image Comparison Slider.
 *
 * React Compare Slider Documentation:
 *  https://www.npmjs.com/package/react-compare-slider
 */
const ImageComparisonSlider = (
  props: ImageComparisonParagraphData
): JSX.Element => {
  const { paragraphData } = props;
  const {
    aspectRatio,
    imageA,
    altTextImageA,
    imageB,
    altTextImageB,
    sliderPosition,
    verticalSlider,
  }: ImageComparisonProps = paragraphData;

  const ratios = {
    '16:9': 'w=1280&h=720',
    '4:3': 'w=1280&h=960',
    '3:4': 'w=720&h=960',
    '1:1': 'w=720&h=720',
  };

  const safeRatio = ratios[aspectRatio] ?? 'w=1280&h=960';
  const urlA = `${getWidenImageUrl(imageA)}?${safeRatio}&crop=true`;
  const urlB = `${getWidenImageUrl(imageB)}?${safeRatio}&crop=true`;

  /**
   * Render.
   */
  return (
    <div className="image-comparison-slider">
      <ReactCompareSlider
        portrait={verticalSlider === 'true'}
        itemOne={<ReactCompareSliderImage src={urlB} alt={altTextImageA} />}
        itemTwo={<ReactCompareSliderImage src={urlA} alt={altTextImageB} />}
        position={parseInt(sliderPosition)}
      />
    </div>
  );
};

export default ImageComparisonSlider;
